import React from 'react';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

function Confirmed({ config, data }) {
  const { getConfirmedText } = config;
  const confirmedText = getConfirmedText(data);

  return (
    <div className="mn_emailUnsubscribe">
      <ContentWrap className="mn_unsubscribeConfirmed">{confirmedText}</ContentWrap>
    </div>
  );
}

export default Confirmed;
